import { apiFetch } from './client'
import type { RebalanceCheckResponse } from '../types/rebalance'

export function fetchRebalanceCheck(
  portfolioId: string,
  mode: string
): Promise<RebalanceCheckResponse> {
  return apiFetch<RebalanceCheckResponse>(
    `/api/strategy/${encodeURIComponent(portfolioId)}/rebalance-check`,
    { method: 'POST', body: JSON.stringify({ mode }) }
  )
}
